import { Dropdown } from "semantic-ui-react";
import GenericToggleButtons from "../components/GenericToggleButtons";

const CodeEntry = ({ elementName, fieldLabel, startingValue, setResourceState, allowedValues, dataEntryStyle, enableCreation, togglable }) => {
    if (!allowedValues) {
      return <></>
    }
    if (enableCreation && !allowedValues.includes('Enter a different value.')) {
      allowedValues.push('Enter a different value.');
    }
    if (dataEntryStyle === "dropdown" || dataEntryStyle === "dropdownsearch") {
      return <div>
        <b>{fieldLabel}: </b>
        <Dropdown
          name={elementName}
          placeholder={fieldLabel}
          search={dataEntryStyle === "dropdownsearch"}
          closeOnChange selection clearable selectOnBlur={false} autoComplete="off"
          style={{ minWidth: "25%", width: "25%" }}
          options={allowedValues.map((code, codeIndex) => { return { "key": codeIndex, "value": code, "text": code } })}
          value={startingValue}
          onChange={(e, data) => {
            setResourceState(prevState => { return { ...prevState, [elementName]: data.value } })
          }}
        />
      </div>
    }
    if (togglable === undefined) {
      togglable = true;
    }
    return <div style={{ marginTop: "8px" }}>
      <b>{fieldLabel}: </b>
      <GenericToggleButtons capitalize={true} medium={true} togglable={togglable}
        values={allowedValues} fieldLabel={fieldLabel} elementName={elementName}
        startingValue={startingValue} setter={setResourceState}
      />
    </div>
  };

  export default CodeEntry;